import React, {useState, useEffect} from "react";
import {VsiBubble, VsiH4,} from "../../../../styled/App.styled";
import {useDataWithRoute, useTitleFromComponent} from "../../../../utils/hooks";
import {useVsiAppContext} from "../../../../stores/VsiApp";
import {Card} from "reactstrap";
import Grid from "../../../../components/Grid";
import {switchesErrorTrend} from "../../../../utils/gridColumnDefs/switches/switchesSummary";
import Stockchart from "../../../../components/Stockchart";
import {useSearchParams} from "react-router-dom";
import {formatStockChartConfig, snakeCaseToTitleCase} from "../../../../utils/Helpers";

const errorFields = ['bb_credit_zero_rx_warning',
    'bb_credit_zero_tx_warning',
    'class_3_discard',
    'crc_errors',
    'frame_too_long_short',
    'link_failure',
    'link_reset',
    'loss_of_sync_signal',
    'port_latency',
    'slow_drain_device'
];

export default function SanPortErrorTrend({context, title}) {
    const [searchParams] = useSearchParams();
    const switchName = decodeURIComponent(searchParams.get('switch_name') || 'N/A');
    useTitleFromComponent(`${switchName} ${context} / ${title}`);
    const { theme, client, periodId } = useVsiAppContext();

    const [{ recordset }, {isLoading}] = useDataWithRoute(`/api/v6/report/switch_port_error_trend_proc?client_id=${client.clientId}&period_id=${periodId}&switch_name=${searchParams.get("switch_name")}`)

    const [errorTrendData, setErrorTrendData] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [chartConfig, setChartConfig] = useState({
            yAxis: [
                {
                    title: {
                        text: 'Errors',
                    }
                }
            ]
        });

    useEffect(() => {
        handleStateWithData(recordset);
        setChartData(recordset);
    }, [recordset]);

    const handleStateWithData = data => {
        const config = formatStockChartConfig(
          (data || [])
        .sort((a, b) => Date.parse(a.collection_date?.split?.('T')?.[0]) - Date.parse(b.collection_date?.split?.('T')?.[0])),
          errorFields.map(field => {
            return {
                name: snakeCaseToTitleCase(field),
                field: field
            }
        }));
        setErrorTrendData(config.series);
    };

    const filterChanged = (eventData) => {
        let rowData = [];
        eventData.api.forEachNodeAfterFilter(node => {
            rowData.push(node.data);
        });

        handleStateWithData(rowData || []);
    };

    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>SAN-Switch Port Error Trend - {switchName}</VsiH4>

            <VsiBubble>
                <Stockchart series={errorTrendData}
                            saveParams={{
                                switchName: switchName,
                            }}
                            config={chartConfig}/>
            </VsiBubble>
            <VsiBubble>
                <Grid addStyle data={chartData}
                      filterChanged={filterChanged}
                      columnDefs={switchesErrorTrend}
                      isLoading={isLoading}/>
            </VsiBubble>
        </Card>
    )
}
